/** Dias da semana no editor de horário do passo URA. */
export const CHATBOT_HORARIO_DAYS = [
  { keyIni: "horario_seg_ini", keyFim: "horario_seg_fim", label: "Segunda-feira" },
  { keyIni: "horario_ter_ini", keyFim: "horario_ter_fim", label: "Terça-feira" },
  { keyIni: "horario_qua_ini", keyFim: "horario_qua_fim", label: "Quarta-feira" },
  { keyIni: "horario_qui_ini", keyFim: "horario_qui_fim", label: "Quinta-feira" },
  { keyIni: "horario_sex_ini", keyFim: "horario_sex_fim", label: "Sexta-feira" },
  { keyIni: "horario_sab_ini", keyFim: "horario_sab_fim", label: "Sábado" },
  { keyIni: "horario_dom_ini", keyFim: "horario_dom_fim", label: "Domingo" },
];

/** Normaliza HH:MM[:SS] do banco / input time. */
export function normalizeHorarioValue(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const hhmm = s.length >= 5 ? s.slice(0, 5) : s;
  if (!/^\d{2}:\d{2}$/.test(hhmm)) return "";
  return hhmm;
}

/**
 * Intervalo “real” (não artefato do input time / save antigo com 00:00–00:00).
 * 00:00→08:00 conta; 00:00→00:00 ou vazio não.
 */
export function isMeaningfulDayHorario(ini, fim) {
  const a = normalizeHorarioValue(ini);
  const b = normalizeHorarioValue(fim);
  if (!a && !b) return false;
  if (a === "00:00" && (!b || b === "00:00")) return false;
  if (b === "00:00" && !a) return false;
  return true;
}

export function dayHorarioActive(form, keyIni, keyFim) {
  return isMeaningfulDayHorario(form?.[keyIni], form?.[keyFim]);
}

export function formHasHorarioRestriction(form) {
  return CHATBOT_HORARIO_DAYS.some((d) => dayHorarioActive(form, d.keyIni, d.keyFim));
}

/** Limpa artefatos 00:00–00:00 ao carregar o slot no formulário. */
export function horarioFieldsFromSlot(slot) {
  const out = {};
  for (const day of CHATBOT_HORARIO_DAYS) {
    const ini = normalizeHorarioValue(slot?.[day.keyIni]);
    const fim = normalizeHorarioValue(slot?.[day.keyFim]);
    if (isMeaningfulDayHorario(ini, fim)) {
      out[day.keyIni] = ini;
      out[day.keyFim] = fim;
    } else {
      out[day.keyIni] = "";
      out[day.keyFim] = "";
    }
  }
  return out;
}

export function clearAllHorarioFields() {
  const out = {};
  for (const day of CHATBOT_HORARIO_DAYS) {
    out[day.keyIni] = "";
    out[day.keyFim] = "";
  }
  return out;
}
